import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import './dailyflash.css'
import SmallLoader from './SmallLoader';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { dataFormatMonthlyCard, removeSpecials } from './functions';
import { removeSpecialChar, removeSpecialCharWithOutDecimal, getPermissions } from '../../app/util';



export default function MonthCard(props) {
    const { auth, app } = useSelector(state => state);
    const { app_state, ui_state } = app.current_state;
    const { profile } = auth;
    const resError = props.resError;
    let {sdlyText, dayDate} = props;
    let sdlyKey = (dayDate === 'day') ? "sdly" : "sdtly";
    const {data , forecastData, budgetData} = props;
    const [monthlyData, setMonthlyData] = React.useState(props.data);
    let currentMonth = moment(app_state.as_of_date).format("MMMM YYYY");
    let firstIndex = 0 , nextIndex = 1 , farIndex = 2;
    
    let result;
    if(props.dataView === "currYear"  ){
        let currMonthNum = parseInt(moment(app_state.as_of_date).format("M"));
        if(currMonthNum >=10){
            currMonthNum = 10;
        }
        firstIndex = currMonthNum -1;
        nextIndex = currMonthNum;
        farIndex = currMonthNum +1;
    }
    if(data && data[firstIndex]){
        currentMonth = moment(data[firstIndex].monthData, "MMM, YYYY").format("MMMM YYYY");
    }
    let primary = { Occ: null, ADR: null, RevPAR: null, Revenue: null }
    let sdly = { Occ: null, ADR: null, RevPAR: null, Revenue: null }

    let primaryNext = { Occ: null, ADR: null, RevPAR: null, Revenue: null }
    let sdlyNext = { Occ: null, ADR: null, RevPAR: null, Revenue: null }

    let primaryFar = { Occ: null, ADR: null, RevPAR: null, Revenue: null }
    let sdlyFar = { Occ: null, ADR: null, RevPAR: null, Revenue: null }

    let forecast = { Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0 }
    let forecastNext = { Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0 }
    let forecastFar = { Occ: 0, ADR: 0, RevPAR: 0, Revenue: 0 }
    let { selectedMarketProperty, availableMarkets } = props;
    let selectedResource = {}
    if (availableMarkets.length > 1) {
        selectedResource = availableMarkets.find(i => i.id === selectedMarketProperty);

    }
    let permissionDetails = getPermissions(profile.property_details, app_state.property_id);
    if (forecastData) {
        // debugger;
        if(forecastData.length > 0){
            forecast = {
                ...forecast,
                Occ: forecastData[0].Occ,
                ADR: forecastData[0].ADR,
                RevPAR: forecastData[0].RevPAR,
                Revenue:forecastData[0].Revenue,
            }
        }
      
        if(forecastData.length > 1  ){
            forecastNext = {
                ...forecastNext,
                Occ: forecastData[1].Occ,
                ADR: forecastData[1].ADR,
                RevPAR: forecastData[1].RevPAR,
                Revenue: forecastData[1].Revenue,
            }
        }
        if(forecastData.length >2  ){
            forecastFar = {
                ...forecastFar,
                Occ: forecastData[2].Occ,
                ADR: forecastData[2].ADR,
                RevPAR: forecastData[2].RevPAR,
                Revenue: forecastData[2].Revenue,
            }
        }
       
    }
    if (data ) {
        if(data.length > firstIndex){
            primary = {
                // LRV-1204
                // ...primary,
                // Occ: data[firstIndex].primary.Occ,
                // ADR: data[firstIndex].primary.ADR,
                // RevPAR: data[firstIndex].primary.RevPAR,
                // Revenue: data[firstIndex].primary.Revenue,
                ...primary,
                Occ: data[firstIndex].primary.Occ !== "" ? data[firstIndex].primary.Occ : "0%",
                ADR: data[firstIndex].primary.ADR !== "" ? data[firstIndex].primary.ADR : ui_state.currency_symbol+0,
                RevPAR: data[firstIndex].primary.RevPAR !== "" ? data[firstIndex].primary.RevPAR : ui_state.currency_symbol+0,
                Revenue: data[firstIndex].primary.Revenue !== "" ? data[firstIndex].primary.Revenue : ui_state.currency_symbol+0,
            }
            sdly = {
                ...sdly,
                Occ: data[firstIndex][sdlyKey].Occ,
                ADR: data[firstIndex][sdlyKey].ADR,
                RevPAR: data[firstIndex][sdlyKey].RevPAR,
                Revenue: data[firstIndex][sdlyKey].Revenue,
            }
            Object.keys(sdly).forEach(key=>{
                if(sdly[key] ==""){
                    sdly[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
                }
            })
            console.log("sdly", sdly, data);
        }else {
            Object.keys(primary).forEach(key=>{
                primary[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
            })
            Object.keys(sdly).forEach(key=>{
                sdly[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
            })
        }
        
        if( data.length > nextIndex){
            primaryNext = {
                // LRV-1204
                // ...primaryNext,
                // Occ: data[nextIndex].primary.Occ,
                // ADR: data[nextIndex].primary.ADR,
                // RevPAR: data[nextIndex].primary.RevPAR,
                // Revenue: data[nextIndex].primary.Revenue,
                ...primaryNext,
                Occ: data[nextIndex].primary.Occ !== "" ? data[nextIndex].primary.Occ : "0%",
                ADR: data[nextIndex].primary.ADR !== "" ? data[nextIndex].primary.ADR : ui_state.currency_symbol+0,
                RevPAR: data[nextIndex].primary.RevPAR !== "" ? data[nextIndex].primary.RevPAR : ui_state.currency_symbol+0,
                Revenue: data[nextIndex].primary.Revenue !== "" ? data[nextIndex].primary.Revenue : ui_state.currency_symbol+0,
            }
            sdlyNext = {
                ...sdlyNext,
                Occ: data[nextIndex][sdlyKey].Occ,
                ADR: data[nextIndex][sdlyKey].ADR,
                RevPAR: data[nextIndex][sdlyKey].RevPAR,
                Revenue: data[nextIndex][sdlyKey].Revenue,
            }
            Object.keys(sdlyNext).forEach(key=>{
                if(sdlyNext[key] ==""){
                    sdlyNext[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
                }
            })
        }else {
            Object.keys(primaryNext).forEach(key=>{
                primaryNext[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
            })
            Object.keys(sdlyNext).forEach(key=>{
                sdlyNext[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
            })
        }
        if( data.length > farIndex){
            primaryFar = {
                // LRV-1204
                // ...primaryFar,
                // Occ: data[farIndex].primary.Occ,
                // ADR: data[farIndex].primary.ADR,
                // RevPAR: data[farIndex].primary.RevPAR,
                // Revenue: data[farIndex].primary.Revenue,
                ...primaryFar,
                Occ: data[farIndex].primary.Occ !== "" ? data[farIndex].primary.Occ : "0%",
                ADR: data[farIndex].primary.ADR !== "" ? data[farIndex].primary.ADR : ui_state.currency_symbol+0,
                RevPAR: data[farIndex].primary.RevPAR !== "" ? data[farIndex].primary.RevPAR : ui_state.currency_symbol+0,
                Revenue: data[farIndex].primary.Revenue !== "" ? data[farIndex].primary.Revenue : ui_state.currency_symbol+0,
                
            }
            sdlyFar = {
                ...sdlyFar,
                Occ: data[farIndex][sdlyKey].Occ,
                ADR: data[farIndex][sdlyKey].ADR,
                RevPAR: data[farIndex][sdlyKey].RevPAR,
                Revenue: data[farIndex][sdlyKey].Revenue,
            }
            Object.keys(sdlyFar).forEach(key=>{
                if(sdlyFar[key] ==""){
                    sdlyFar[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
                }
            })
        }else {
            Object.keys(primaryFar).forEach(key=>{
                primaryFar[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
            })
            Object.keys(sdlyFar).forEach(key=>{
                sdlyFar[key]=key==="Occ" ? 0+"%" : ui_state.currency_symbol+0;
            })
        }
       

    }

    let budgetCurrent;
    let budgetNext;
    let budgetFar;
    // debugger; 
    if (budgetData) {
        budgetCurrent = budgetData[0];
        budgetNext = budgetData[1];
        budgetFar = budgetData[2];
    }

    const UpIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                fill="#69DB7C"
                viewBox="0 0 256 256"
            >
                <path d="M205.66,117.66a8,8,0,0,1-11.32,0L136,59.31V216a8,8,0,0,1-16,0V59.31L61.66,117.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,117.66Z"></path>
            </svg>
        );
    };
    const DownIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                fill="#FF6B6B"
                viewBox="0 0 256 256"
            >
                <path d="M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"></path>
            </svg>
        );
    };

    return (
        <Grid container justifyContent="space-between" spacing={1}>
            <Grid item xs={4}>
                <Card className='card-container'>
                    <CardContent>
                        <Typography className='card-date-title'>
                            {currentMonth}
                        </Typography>
                        <Box className='card-content-box'>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 2 }} sx={{ mt: 1, pl: 1.9 }}>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Occupancy</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Avg. Daily Rate</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primary.Occ != null) ? primary.Occ : <SmallLoader />}
                                    </span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primary.ADR != null) ? primary.ADR : <SmallLoader />}

                                    </span>
                                </Grid>

                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text capitalize'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'> {resError ? "No Data" : (sdly.Occ != null) ? sdly.Occ : <SmallLoader />}</div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                        (sdly.Occ && primary.Occ && primary.Occ > sdly.Occ) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError || permissionDetails.permissions.hfc === 0 || !forecast.Occ ? "No Data" : (forecast.Occ) ? forecast.Occ : <SmallLoader />}</div>
                                            {forecast.Occ !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecast.Occ ? null :
                                                        (forecast.Occ && primary.Occ && primary.Occ > forecast.Occ) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetCurrent && budgetCurrent.Occ) ? budgetCurrent.Occ : "No Data"}
                                            </div>
                                            {budgetCurrent && budgetCurrent.Occ !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primary.Occ, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetCurrent.Occ, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                </Grid>
                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError ? "No Data" : (sdly.ADR != null) ? sdly.ADR : <SmallLoader />}
                                            </div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                        (sdly.ADR && primary.ADR && parseInt(removeSpecialChar(primary.ADR, ui_state.currency_symbol)) > parseInt(removeSpecialChar(sdly.ADR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                }

                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError || permissionDetails.permissions.hfc === 0 || !forecast.ADR ? "No Data" : (forecast.ADR) ? forecast.ADR : <SmallLoader />}</div>
                                            {forecast.ADR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecast.ADR ? null :
                                                        (forecast.ADR && primary.ADR && parseInt(removeSpecialChar(primary.ADR, ui_state.currency_symbol)) > parseInt(removeSpecialChar(forecast.ADR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetCurrent && budgetCurrent.ADR) ? budgetCurrent.ADR : "No Data"}
                                            </div>
                                            {budgetCurrent && budgetCurrent.ADR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primary.ADR, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetCurrent.ADR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                            <Grid container rowSpacing={1} columnSpacing={{ xs: 2 }} sx={{ mt: 2, pl: 1.9 }}>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Rev Par</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Revenue</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primary.RevPAR != null) ? primary.RevPAR : <SmallLoader />}
                                    </span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {/* { removeSpecialChar(primary.Revenue)} */}
                                        {resError ? "No Data" : (primary.Revenue != null) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(primary.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}
                                    </span>
                                </Grid>

                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError ? "No Data" : (sdly.RevPAR != null) ? sdly.RevPAR : <SmallLoader />}</div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    //    (sdly.RevPAR && primary.RevPAR && primary.RevPAR > sdly.RevPAR) ? 
                                                    resError ? null :
                                                        (sdly.RevPAR && primary.RevPAR && parseInt(removeSpecialChar(primary.RevPAR, ui_state.currency_symbol)) > parseInt(removeSpecialChar(sdly.RevPAR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError || permissionDetails.permissions.hfc === 0 || !forecast.RevPAR ? "No Data" : (forecast.RevPAR) ? forecast.RevPAR : <SmallLoader />}</div>
                                            {forecast.RevPAR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecast.RevPAR ? null :
                                                        (forecast.RevPAR && primary.RevPAR && Number(removeSpecialChar(primary.RevPAR, ui_state.currency_symbol)) > Number(removeSpecialChar(forecast.RevPAR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetCurrent && budgetCurrent.RevPAR) ? budgetCurrent.RevPAR : "No Data"}
                                            </div>
                                            {budgetCurrent && budgetCurrent.RevPAR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primary.RevPAR, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetCurrent.RevPAR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                </Grid>
                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError ? "No Data" : (sdly.Revenue != null) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(sdly.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</div>
                                            <div className='card-data-text-arrow'>

                                                {
                                                    resError ? null :
                                                        (sdly.Revenue && primary.Revenue && Number(removeSpecialChar(primary.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(sdly.Revenue, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div> 
                                    
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError || permissionDetails.permissions.hfc === 0 || !forecast.Revenue ? "No Data" : (forecast.Revenue) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(forecast.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</div>
                                            {forecast.Revenue !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecast.Revenue ? null :
                                                        (forecast.Revenue && primary.Revenue && Number(removeSpecialChar(primary.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(forecast.Revenue, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div> 
                                    
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetCurrent && budgetCurrent.Revenue) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(budgetCurrent.Revenue, ui_state.currency_symbol), ui_state)  : "No Data"}
                                            </div>
                                            {budgetCurrent && budgetCurrent.Revenue !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primary.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetCurrent.Revenue, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                        </Box>
                    </CardContent>

                </Card>
            </Grid>

            <Grid item xs={4}>
                <Card className='card-container'>
                    <CardContent>
                        <Typography className='card-date-title'>
                            {moment(currentMonth).add(1, "month").format("MMMM YYYY")}
                        </Typography>
                        <Box className='card-content-box'>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 2 }} sx={{ mt: 1, pl: 1.9 }}>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Occupancy</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Avg. Daily Rate</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryNext.Occ != null) ? primaryNext.Occ : <SmallLoader />}
                                    </span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryNext.ADR != null) ? primaryNext.ADR : <SmallLoader />}

                                    </span>
                                </Grid>

                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError ? "No Data" : (sdlyNext.Occ != null) ? sdlyNext.Occ : <SmallLoader />}
                                            </div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                        (sdlyNext.Occ && primaryNext.Occ && Number(removeSpecialChar(primaryNext.Occ, ui_state.currency_symbol)) > Number(removeSpecialChar(sdlyNext.Occ, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError || permissionDetails.permissions.hfc === 0 || !forecastNext.Occ ? "No Data" : (forecastNext.Occ) ? forecastNext.Occ : <SmallLoader />}
                                            </div>
                                            {forecastNext.Occ !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastNext.Occ ? null :
                                                        (forecastNext.Occ && primaryNext.Occ && parseInt(removeSpecialChar(primaryNext.Occ, ui_state.currency_symbol)) > parseInt(removeSpecialChar(forecastNext.Occ, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div> 
                                    
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetNext && budgetNext.Occ) ? budgetNext.Occ : "No Data"}

                                            </div>
                                            {budgetNext && budgetNext.Occ !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryNext.Occ, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetNext.Occ, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                </Grid>
                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError ? "No Data" : (sdlyNext.ADR != null) ? sdlyNext.ADR : <SmallLoader />}
                                            </div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                    (sdlyNext.ADR && primaryNext.ADR && parseInt(removeSpecialChar(primaryNext.ADR, ui_state.currency_symbol)) > parseInt(removeSpecialChar(sdlyNext.ADR, ui_state.currency_symbol))) ?
                                                        <UpIcon />
                                                        :
                                                        <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'> {resError || permissionDetails.permissions.hfc === 0 || !forecastNext.ADR ? "No Data" : (forecastNext.ADR) ? forecastNext.ADR : <SmallLoader />}</div>
                                            {forecastNext.ADR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastNext.ADR ? null :
                                                        (forecastNext.ADR && primaryNext.ADR && parseInt(removeSpecialChar(primaryNext.ADR, ui_state.currency_symbol)) > parseInt(removeSpecialChar(forecastNext.ADR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetNext && budgetNext.ADR ) ? budgetNext.ADR : "No Data"}
                                            </div>
                                            {budgetNext && budgetNext.ADR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryNext.ADR, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetNext.ADR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                            <Grid container rowSpacing={1} columnSpacing={{ xs: 2 }} sx={{ mt: 2, pl: 1.9 }}>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Rev Par</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Revenue</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryNext.RevPAR != null) ? primaryNext.RevPAR : <SmallLoader />}
                                    </span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryNext.Revenue != null) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(primaryNext.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</span>
                                </Grid>

                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError ? "No Data" : (sdlyNext.RevPAR != null) ? sdlyNext.RevPAR : <SmallLoader />}
                                            </div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                    (sdlyNext.RevPAR && primaryNext.RevPAR && parseInt(removeSpecialChar(primaryNext.RevPAR, ui_state.currency_symbol)) > parseInt(removeSpecialChar(sdlyNext.RevPAR, ui_state.currency_symbol))) ?
                                                        <UpIcon />
                                                        :
                                                        <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'> {resError || permissionDetails.permissions.hfc === 0 || !forecastNext.RevPAR ? "No Data" : (forecastNext.RevPAR) ? forecastNext.RevPAR : <SmallLoader />}</div>
                                            {forecastNext.RevPAR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastNext.RevPAR ? null :
                                                        (forecastNext.RevPAR && primaryNext.RevPAR && parseInt(removeSpecialChar(primaryNext.RevPAR, ui_state.currency_symbol)) > parseInt(removeSpecialChar(forecastNext.RevPAR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetNext && budgetNext.RevPAR) ? budgetNext.RevPAR : "No Data"}
                                            </div>
                                            {budgetNext && budgetNext.RevPAR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryNext.RevPAR, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetNext.RevPAR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                </Grid>
                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError ? "No Data" : (sdlyNext.Revenue != null) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(sdlyNext.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                    (sdlyNext.Revenue && primaryNext.Revenue && parseInt(removeSpecialChar(primaryNext.Revenue, ui_state.currency_symbol)) > parseInt(removeSpecialChar(sdlyNext.Revenue, ui_state.currency_symbol))) ?
                                                        <UpIcon />
                                                        :
                                                        <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div> 
                                    
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'> {resError || permissionDetails.permissions.hfc === 0 || !forecastNext.Revenue ? "No Data" : (forecastNext.Revenue) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(forecastNext.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</div>
                                            {forecastNext.Revenue !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastNext.Revenue ? null :
                                                        (forecastNext.Revenue && primaryNext.Revenue && Number(removeSpecialChar(primaryNext.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(forecastNext.Revenue, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetNext && budgetNext.Revenue) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(budgetNext.Revenue, ui_state.currency_symbol), ui_state)  : "No Data"}
                                            </div>
                                            {budgetNext && budgetNext.Revenue !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryNext.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetNext.Revenue, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                        </Box>
                    </CardContent>

                </Card>
            </Grid>
            <Grid item xs={4}>
                <Card className='card-container'>
                    <CardContent>
                        <Typography className='card-date-title'>
                            {moment(currentMonth).add(2, "month").format("MMMM YYYY")}
                        </Typography>
                        <Box className='card-content-box'>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 2 }} sx={{ mt: 1, pl: 1.9 }}>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Occupancy</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Avg. Daily Rate</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryFar.Occ != null) ? primaryFar.Occ : <SmallLoader />}
                                    </span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryFar.ADR != null) ? primaryFar.ADR : <SmallLoader />}

                                    </span>
                                </Grid>

                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'> {resError ? "No Data" : (sdlyFar.Occ != null) ? sdlyFar.Occ : <SmallLoader />}</div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                    (sdlyFar.Occ && primaryFar.Occ && parseInt(removeSpecialChar(primaryFar.Occ, ui_state.currency_symbol)) > parseInt(removeSpecialChar(sdlyFar.Occ, ui_state.currency_symbol))) ?
                                                        <UpIcon />
                                                        :
                                                        <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div> 
                                    
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'> {resError || permissionDetails.permissions.hfc === 0 || !forecastFar.Occ ? "No Data" : (forecastFar.Occ) ? forecastFar.Occ : <SmallLoader />}</div>
                                            {forecastFar.Occ !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastFar.Occ ? null :
                                                        (forecastFar.Occ && primaryFar.Occ && Number(removeSpecialChar(primaryFar.Occ, ui_state.currency_symbol)) > Number(removeSpecialChar(forecastFar.Occ, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div> 
                                    
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetFar && budgetFar.Occ) ? budgetFar.Occ : "No Data"}
                                            </div>
                                            {budgetFar && budgetFar.Occ !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryFar.Occ, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetFar.Occ, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                </Grid>

                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError ? "No Data" : (sdlyFar.ADR != null) ? sdlyFar.ADR : <SmallLoader />}
                                            </div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                    (sdlyFar.ADR && primaryFar.ADR && Number(removeSpecialChar(primaryFar.ADR, ui_state.currency_symbol)) > Number(removeSpecialChar(sdlyFar.ADR, ui_state.currency_symbol))) ?
                                                        <UpIcon />
                                                        :
                                                        <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast </div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError || permissionDetails.permissions.hfc === 0 || !forecastFar.ADR ? "No Data" : (forecastFar.ADR) ? forecastFar.ADR : <SmallLoader />}</div>
                                            {forecastFar.ADR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastFar.ADR ? null :
                                                        (forecastFar.ADR && primaryFar.ADR && Number(removeSpecialChar(primaryFar.ADR, ui_state.currency_symbol)) > Number(removeSpecialChar(forecastFar.ADR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetFar && budgetFar.ADR) ? budgetFar.ADR : "No Data"}
                                            </div>
                                            {budgetFar && budgetFar.ADR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryFar.ADR, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetFar.ADR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                            <Grid container rowSpacing={1} columnSpacing={{ xs: 2 }} sx={{ mt: 2, pl: 1.9 }}>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Rev Par</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-title'>Revenue</span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryFar.RevPAR != null) ? primaryFar.RevPAR : <SmallLoader />}
                                    </span>
                                </Grid>
                                <Grid item xs={6}>
                                    <span className='card-data-main-text'>
                                        {resError ? "No Data" : (primaryFar.Revenue != null) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(primaryFar.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</span>
                                </Grid>

                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {resError ? "No Data" : (sdlyFar.RevPAR !== null) ? sdlyFar.RevPAR : <SmallLoader />}
                                            </div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                    (sdlyFar.RevPAR && primaryFar.RevPAR && Number(removeSpecialChar(primaryFar.RevPAR, ui_state.currency_symbol)) > Number(removeSpecialChar(sdlyFar.RevPAR, ui_state.currency_symbol))) ?
                                                        <UpIcon />
                                                        :
                                                        <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast </div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError || permissionDetails.permissions.hfc === 0 || !forecastFar.RevPAR ? "No Data" : (forecastFar.RevPAR) ? forecastFar.RevPAR : <SmallLoader />}</div>
                                            {forecastFar.RevPAR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastFar.RevPAR ? null :
                                                        (forecastFar.RevPAR && primaryFar.RevPAR && Number(removeSpecialChar(primaryFar.RevPAR, ui_state.currency_symbol)) > Number(removeSpecialChar(forecastFar.RevPAR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetFar && budgetFar.RevPAR ) ? budgetFar.RevPAR : "No Data"}
                                            </div>
                                            {budgetFar && budgetFar.RevPAR !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryFar.RevPAR, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetFar.RevPAR, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                </Grid>
                                <Grid item xs={6}>
                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>{sdlyText}</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError ? "No Data" : (sdlyFar.Revenue != null) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(sdlyFar.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</div>
                                            <div className='card-data-text-arrow'>
                                                {
                                                    resError ? null :
                                                    (Number(removeSpecialChar(primaryFar.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(sdlyFar.Revenue, ui_state.currency_symbol))) ?
                                                        //    ( removeSpecialCharWithOutDecimal(primaryFar.Revenue) > removeSpecialCharWithOutDecimal(sdlyFar.Revenue) ) ? 
                                                        <UpIcon />
                                                        :
                                                        <DownIcon />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Forecast</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>{resError || permissionDetails.permissions.hfc === 0 || !forecastFar.Revenue ? "No Data" : (forecastFar.Revenue) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(forecastFar.Revenue, ui_state.currency_symbol), ui_state) : <SmallLoader />}</div>
                                            {forecastFar.Revenue !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        resError || permissionDetails.permissions.hfc === 0 || !forecastFar.Revenue ? null :
                                                        (Number(removeSpecialChar(primaryFar.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(forecastFar.Revenue, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='month-card-data-row'>
                                        <div className='card-data-text'>Budget</div>
                                        <div className='month-card-data-value'>
                                            <div className='card-data-text'>
                                                {(budgetFar && budgetFar.Revenue) ? dataFormatMonthlyCard("Revenue", removeSpecialChar(budgetFar.Revenue, ui_state.currency_symbol), ui_state)  : "No Data"}

                                            </div>
                                            {budgetFar && budgetFar.Revenue !== null &&
                                                <div className='card-data-text-arrow'>
                                                    {
                                                        (Number(removeSpecialChar(primaryFar.Revenue, ui_state.currency_symbol)) > Number(removeSpecialChar(budgetFar.Revenue, ui_state.currency_symbol))) ?
                                                            <UpIcon />
                                                            :
                                                            <DownIcon />
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Grid>

                            </Grid>

                        </Box>
                    </CardContent>

                </Card>
            </Grid>

        </Grid>
    );
}